<template>
  <div id="customer-knowledge-popup">
    <vs-popup
        :active.sync="isActive"
        :button-close-hidden="inFlow"
        :class="{'style-in-flow' : inFlow}"
        :title="!inFlow ? 'Modelo de Dados do Cliente' : ''"
        @close="$emit('closeModalCustomerKnow')"
    >
      <div v-if="inFlow" class="mb-10">
        <div id="display-span-orders">
          <vs-icon @click="isUpdate ? $emit('backUpdateKnow', false) : $emit('backPage')" class="mr-2" icon="keyboard_arrow_left" style="border: solid 1px; border-radius: 14px; cursor: pointer;"/>
          <p class="ml-6 title-popup"> Modelo de Dados do Cliente (Opcional)</p>
          <div class="flex-end-align title-close-button">
            <vs-icon @click="$emit('closeModalCustomerKnow')" class="mr-2" icon="close"></vs-icon>
          </div>
        </div>

        <div class="mt-8">
          <vs-divider>
            Selecione um Modelo de Dados do Cliente
          </vs-divider>

          <v-select
              class="w-full mb-4 "
              label="description"
              v-model="currentKnowId"
              :options="knowledge"
              :reduce="(option) => option.id"
              @input="changeKnow">
          </v-select>
        </div>
      </div>

      <div v-if="currentKnow">
        <vs-divider>
          {{ currentKnow.description }}
        </vs-divider>

        <vs-textarea
          v-validate="'required'"
          v-if="currentKnow.use_observation && currentKnow.require_observation"
          name="observation" class="w-full" label="Observações" v-model="observation"
          :required="currentKnow.require_observation"
        ></vs-textarea>

        <vs-textarea
          v-else-if="currentKnow.use_observation"
          :required="currentKnow.require_observation"
          name="observation" class="w-full" label="Observações" v-model="observation"
        ></vs-textarea>

        <span class="text-danger text-sm mb-6" v-show="errors.has('observation')">
          Campo observação é obrigatório
        </span>

        <div class="clear"></div>

        <div>
          <component
            v-for="(option, index) in options"
            :description="currentKnow.reason_options[index].description"
            :items="responses[index]"
            :index="index"
            :key="index"
            :is="option"
            @valueChanged="updateValue"
          />
        </div>

        <div class="text-center mt-5" v-if="!inFlow">
          <vs-button
              type="filled"
              @click.stop="setKnow"
              class="bg-primary-gradient ml-4"
              :disabled="!canSee('knowledge-add')"
          >Salvar</vs-button>
        </div>
      </div>

      <div class="mt-5" v-if="inFlow">
        <vs-button @click="setKnow" class="btn-drop px-3 mr-5 mt-2" type="filled" icon="keyboard_arrow_right" icon-after style="float: right !important; border-radius: 12px;">
          <span>{{ !currentKnow ? 'Próximo/Pular' : 'Atualizar' }}</span>
        </vs-button>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import vSelect         from 'vue-select';
import IntField        from '@/views/reason-response-fields/Int'
import TextField       from '@/views/reason-response-fields/Text'
import RadioField      from '@/views/reason-response-fields/Radio'
import SelectField     from '@/views/reason-response-fields/Select'
import BooleanField    from '@/views/reason-response-fields/Boolean'
import DecimalField    from '@/views/reason-response-fields/Decimal'
import CurrencyField   from '@/views/reason-response-fields/Currency'
import CheckboxField   from '@/views/reason-response-fields/Checkbox'

import customerKnow       from '@/http/requests/knowledge';
import orderApi          from "@/http/requests/orders";
import { knowledgeType }  from "@/supports/reasonSupport";
import requests           from "@/http/requests/reasons";
import { hasPermission }  from "@/utils";

export default {
  name: 'customer-knowledge-popup',
  props: {
    customerId: {
      required: true
    },
    isActive: {
      type: Boolean,
      required: true
    },
    inFlow: {
      type: Boolean,
      required: false,
      default(){ return false; }
    },
    isUpdate: {
      type: Boolean,
      required: false,
      default(){ return false; }
    },
    currentKnow: {
      required: true,
      validator: prop => typeof prop === 'object' || prop === null
    },
    dataOfTurnIntoOrder: {
      type: Object,
      required: false
    }
  },
  data() {
    return {
      options: [],
      responses: [],
      knowledge: [],
      customerKnow: [],
      observation: null,
      currentKnowId: null
    }
  },
  provide() {
    return {
      $validator: this.$validator,
    }
  },
  emits: [ 'knowledgeClose', 'setCurrentKnow', 'backPage' ],
  components: { vSelect, IntField, TextField, RadioField, SelectField, DecimalField, BooleanField, CheckboxField, CurrencyField },
  watch: {
    currentKnowId(val) {
      const nowKnow = this.knowledge.filter((know) => { return know.id === val })[0];
      this.$emit('setCurrentKnow', nowKnow)
    },
    async isActive(val){
      if ( val ){
        this.options       = [];
        this.responses     = [];
        this.customerKnow  = [];
        this.observation   = null;
        this.currentKnowId = this.currentKnow ? this.currentKnow.id : null;

        if (this.isUpdate) {
          this.currentKnowId = this.dataOfTurnIntoOrder.reason.id;
          this.customerId    = this.dataOfTurnIntoOrder.chatTicket.customer.id;
          
          await this.loadKnowledge();
          const nowKnow = this.knowledge.filter((know) => { return know.id === this.dataOfTurnIntoOrder.reason.id })[0];
          this.$emit('setCurrentKnow', nowKnow)
        }

        if ( this.inFlow ){ return this.loadKnowledge() }
        this.fetchCustomerKnow()
      }
    }
  },
  methods: {
    changeKnow(){
      setTimeout(() => this.fetchCustomerKnow(), 50);
    },
    canSee(action) {
      return hasPermission(`${this.$route.name}-${action}`)
    },
    async validate(){
      let main      = await this.$validator.validateAll().then(result => { return result; });
      let children  = this.$children.map( async child => { return await child.$validator.validateAll(); });
      children      = await Promise.all(children).then( results => { return results; })
      return main && !children.includes(false);
    },
    updateValue(index, itemIndex, value) {
      let opts = {
        reason_option_is_required: this.responses[index][itemIndex].reason_option_is_required,
        reason_option_item_id: this.responses[index][itemIndex].reason_option_item_id,
        reason_option_id: this.responses[index][itemIndex].reason_option_id,
        description: this.responses[index][itemIndex].description,
        value: value.toString()
      }
      let list = this.responses[index]
      list.splice(itemIndex, 1, opts)
      this.responses.splice(index, 1, list)
    },
    async setKnow(){
      if (await this.validate()) {
        if ( !this.currentKnow ) {
          if (this.isUpdate) {
            orderApi.update({id: this.dataOfTurnIntoOrder.id, currentKnow: JSON.stringify(this.currentKnow)})
            return this.$emit('backUpdateKnow', true);
          }
          else {
            return this.$emit('knowledgeClose', this.inFlow);
          }
       }

        let args = {
          id: this.customerId,
          observation: this.observation,
          reasonId: this.currentKnow.id,
          reason_responses: this.responses
        }

        customerKnow.add(args).then(() => {
          if (this.isUpdate) {
            orderApi.update({id: this.dataOfTurnIntoOrder.id, currentKnow: JSON.stringify(this.currentKnow)})
            this.$emit('backUpdateKnow', true);
          }
          else {
            this.$emit('knowledgeClose', this.inFlow);
          }

          this.$vs.notify({
            color: 'success',
            title: 'Adicionado ao Modelo de Dados do Cliente!',
          });
        }).catch((error) => { console.error(error) })
      }
    },
    async loadKnowledge() {
      this.knowledge = [];
      await requests.fetch({deleted: false, type: knowledgeType})
        .then((response) => {
          this.knowledge = response.data.data.reasons;
          this.fetchCustomerKnow()
        }).catch((error) => { console.error(error) })
    },
    fetchCustomerKnow() {
      if ( !this.currentKnow ){ return }

      customerKnow.fetch(this.customerId, this.currentKnowId)
        .then((response) => {
          this.customerKnow = response.data.data.customerKnowledge[0]
          this.prepareOptionsKnow()
        }).catch((error) => { console.error(error) })
    },
    prepareOptionsKnow(){
      if( !this.customerKnow ){ return this.resetOptions(); }

      this.currentKnowId  = this.customerKnow.reason_id
      let observation     = this.customerKnow.observation
      let knowOption      = this.customerKnow.reason_option

      this.resetOptions()
      this.loadOptionsKnow(observation, knowOption)
    },
    loadOptionsKnow(observation, knowOption){
      let currentOptions = this.currentKnow.reason_options
      if (!currentOptions) { return; }

      this.observation = !observation.includes('null') ? observation : null

      knowOption.forEach((option) => {
        let knowOptionIndex = currentOptions.findIndex((e) => { return e.id == parseInt(option.id) })
        if ( knowOptionIndex === -1 ){ return; }

        let knowItemIndex = currentOptions[knowOptionIndex].reason_option_items.findIndex((e) => { return e.id == parseInt(option.option_item_id) })
        knowItemIndex     = knowItemIndex !== -1 ? knowItemIndex : 0

        if ( option.type === "select" || option.type === "radio" ){
          this.updateValue(knowOptionIndex, knowItemIndex, true)
        } else {
          this.updateValue(knowOptionIndex, knowItemIndex, option.value)
        }

        if (option.type === "checkbox") {
          option.value.split(',').forEach((value) => {
            knowItemIndex = currentOptions[knowOptionIndex].reason_option_items.findIndex((e) => { return e.description == value })
            if ( knowItemIndex !== -1 ) { this.updateValue(knowOptionIndex, knowItemIndex, true) }
          })
        }
      })
    },
    resetOptions() {
      this.options = []
      this.responses = []
      this.customerKnow = []

      if ( !this.currentKnow ) { return }
      if ( !this.currentKnow.reason_options ) { return }
      if ( this.currentKnow.reason_options.length === 0 ) { return }

      this.currentKnow.reason_options.forEach((opt, idx) => {
        let defaultValue = null

        if (opt.reason_option_kind.tag === 'text') {
          this.options.push(TextField)
        }

        if (opt.reason_option_kind.tag === 'int') {
          this.options.push(IntField)
          defaultValue = "0"
        }

        if (opt.reason_option_kind.tag === 'currency') {
          this.options.push(CurrencyField)
          defaultValue = "0"
        }

        if (opt.reason_option_kind.tag === 'decimal') {
          this.options.push(DecimalField)
          defaultValue = "0"
        }

        if (opt.reason_option_kind.tag === 'select') {
          this.options.push(SelectField)
        }

        if (opt.reason_option_kind.tag === 'radio') {
          this.options.push(RadioField)
          defaultValue = "false"
        }

        if (opt.reason_option_kind.tag === 'checkbox') {
          this.options.push(CheckboxField)
          defaultValue = "false"
        }

        if (opt.reason_option_kind.tag === 'boolean') {
          this.options.push(BooleanField)
          defaultValue = "false"
        }

        let items = [null]
        if (opt.reason_option_items && opt.reason_option_items.length > 0) {
          items = opt.reason_option_items
        }

        items.forEach((item) => {
          let itemId = null
          let itemDescription = null
          this.responses[idx] = this.responses[idx] ? this.responses[idx] : []

          if (item) {
            itemId = item.id
            itemDescription = item.description
          }

          this.responses[idx].push({
            reason_option_is_required: opt.is_required,
            reason_option_item_id: itemId,
            description: itemDescription,
            reason_option_id: opt.id,
            value: defaultValue
          })
        })
      })
    },
  }
}
</script>

<style lang="scss">
.style-in-flow {
  .vs-popup {
    .title-popup{
      width: 50rem;
      display: flex;
      font-size: 16px;
      flex-direction: row;
      align-items: center;
      justify-content: flex-start;
    }
    .title-close-button{
      i{
        float: right;
        transform: scaleX(-1);
        --webkit-transform: scaleX(-1);
      }
    }
    .vs-popup--content {
      padding: 15px;
      margin: 0;
    }
    margin: 0;
    border-radius: 18px !important;
    border: solid 1.2px;
    border-color: rgba(18, 17, 17, 0.769);
    width: 700px !important;
    .vs-popup--header {
      background-color: transparent !important;
      .vs-popup--title {
        background-color: transparent !important;
        h3 {
          background-color: transparent !important;
        }
      }
    }
    header {
      background-color: transparent !important;
    }
    input.vs-inputx.vs-input--input.normal {
      border-radius: 14px !important;
      width: 300px;
    }
    li div:first-of-type {
      height: 70px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 20px;
      > img {
        width: 100px !important;
        display: block !important;
        align-items: center;
        justify-content: center;
      }
    }
    ul.leftx {
      display: flex;
      justify-content: space-evenly;
      flex-direction: row;
      align-items: center;
      text-align: center;
      margin-top: 50px;
    }
    *,
    *::before,
    *::after {
      box-sizing: border-box;
    }
    #myselect {
      width: 150px;
      border-radius: 14px;
      border-color:  #b6bebdd2;
      background-color: transparent;
      height: 35px;
      padding-left: 10px;
      font-size: 15px;
    }
    #myinput {
      width: 115px;
      box-shadow: none !important;
      border:none !important;
      background-color: transparent;
      height: 35px;

      font-size: 15px;
      background-color: transparent;
    }
  }
}
</style>